import React, { useContext } from 'react';
import { required } from '@ubeya/shared/utils/form';
import CheckBoxField from '../../FormFields/CheckBoxField';
import InputField from '../../FormFields/InputField';
import NumberField from '../../FormFields/NumberField';
import ConfigContext from '../../../contexts/ConfigContext';
import { EditableByAdmins } from './EditableByAdmins';

const SliderFieldForm = ({ showLimitEditAdminsToggle = false }) => {
  const { t } = useContext(ConfigContext);

  return (
    <>
      <InputField
        name="name"
        title={t('name')}
        placeholder={t('selectNameToField')}
        className="full"
        validate={required}
        required
        autoFocus
      />
      <NumberField name="min" title={t('from')} />
      <NumberField name="max" title={t('to')} />
      <CheckBoxField name="isFloat" title={t('isFloat')} />
      {showLimitEditAdminsToggle && <EditableByAdmins />}
    </>
  );
};

export default SliderFieldForm;
